export const isE2ETest = process.env.NEXT_PUBLIC_E2E_TESTING_MODE === 'true';
